import Button from './button';
import PropTypes from 'prop-types';
import React from 'react';
import {styled} from '@mui/material/styles';

const MapButton = styled(({active, ...props}) => (
  <Button active={active ? 1 : 0} {...props} />
))(({theme}) => ({
  minWidth: 40,
  width: 40,
  height: 40,
  marginTop: theme.spacing(1),
  boxShadow: theme.shadows[4],
}));

MapButton.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func.isRequired,
  'data-qe': PropTypes.string,
};

export default MapButton;
